var CurrentUser = require('lib/account/CurrentUser');

var Modal = require("components/utility/AltModal");

require("notifications/site_annoucement_modal.scss");

class SiteAnnoucementModal extends React.Component {
    constructor(props) {
        super();
        autobind(this);

        this.state = {
            hide: false
        };
    }

    ///// HELPERS /////
    deleteAlert() {
        if (this.props.alertID) {
            CurrentUser.api().deleteUserAlert(this.props.alertID, (res) => {
                this.setState({ hide: true });
                var newUserAlerts = _.filter(CurrentUser.get().user_alerts, alert => { return alert.data.annoucement_key !== res.user_alert.data.annoucement_key })
                CurrentUser.updateLocal({ user_alerts: newUserAlerts })
            });
        }
    }
    
    //////// Render Methods ////////

    render() {
        if (this.state.hide) { return null }

        var { title, actionButtons, bodyContent } = this.props

        return (
            <Modal className="siteAnnoucementModal" ref="siteAnnoucementModal" headerText={title || ''} onHide={this.deleteAlert}  >
                {bodyContent}
            </Modal>
        )
    }

    componentDidMount() {
        this.refs.siteAnnoucementModal.show();
    }
};

SiteAnnoucementModal.propTypes = StrictPropTypes({
    bodyContent: PropTypes.object.isRequired,
    title: PropTypes.string,
    titleImage: PropTypes.string,
    alertID: PropTypes.number,
});

module.exports = SiteAnnoucementModal;



// WEBPACK FOOTER //
// ./modules/components/notifications/SiteAnnoucementModal.js